import type {
    CreateRevisionRequest as ServerCreateRevisionRequest,
    CreateRevisionResponse as ServerCreateRevisionResponse
} from '@wix/ambassador-document-management-editor-server-v1-site-revision/types'

import {
    type Action,
    type TransientActionData as ActionTransientData,
    type PendingTransaction,
    type TransactionGroup,
    type Transaction,
    type TransactionInitiator,
    type SaveRequest as ServerSaveRequest,
    type SaveResponse,
    type GetDocumentRequest,
    type GetDocumentResponse,
    type Metadata,
    type CreateTransactionRequest as ServerCreateTransactionRequest,
    type CreateTransactionResponse as ServerCreateTransactionResponse,
    type DeleteTransactionsRequest,
    type DeleteTransactionsResponse,
    type GetTransactionsRequest,
    type GetTransactionsResponse,
    type GetTransactionRequest,
    type GetTransactionResponse,
    type FragmentTypesFilter,
    ActionOperation,
    InitiatorType
} from '@wix/ambassador-document-management-document-store-v1-transaction/types' // eslint-disable-line wix-editor/no-internal-import

import type {
    GetSchemaCollectionRequest,
    GetSchemaCollectionResponse,
    GetSchemaCollectionsByAppIdsRequest,
    GetSchemaCollectionsByAppIdsResponse,
    SchemaCollection,
    NamespaceSchema,
    Reference,
    InnerSchemaCollection
} from '@wix/ambassador-dm-schema-collection-v1-schema-collection/types'

export type {
    ServerCreateRevisionResponse,
    Action,
    ActionTransientData,
    PendingTransaction,
    TransactionGroup,
    Transaction,
    TransactionInitiator,
    SaveResponse,
    GetDocumentRequest,
    GetDocumentResponse,
    Metadata,
    DeleteTransactionsRequest,
    DeleteTransactionsResponse,
    GetTransactionsRequest,
    GetTransactionsResponse,
    GetTransactionRequest,
    GetTransactionResponse,
    FragmentTypesFilter,
    GetSchemaCollectionRequest,
    GetSchemaCollectionResponse,
    GetSchemaCollectionsByAppIdsRequest,
    GetSchemaCollectionsByAppIdsResponse,
    SchemaCollection,
    NamespaceSchema,
    Reference,
    InnerSchemaCollection
}

export {ActionOperation, InitiatorType}

type String = string

export interface CreateSingleTransactionRequest extends Omit<ServerCreateTransactionRequest, 'atomicTransaction'> {}

export interface CreateAtomicTransactionRequest extends Omit<ServerCreateTransactionRequest, 'actions' | 'metadata'> {}

export type CreateTransactionRequest = CreateSingleTransactionRequest | CreateAtomicTransactionRequest

export interface CreateTransactionResponse extends ServerCreateTransactionResponse {
    requestId?: String
}

export interface TransactionObject {
    transaction?: PendingTransaction
}

export interface TransactionGroupObject {
    transactionGroup?: TransactionGroup
}

export type AtomicTransaction = TransactionObject | TransactionGroupObject

export interface SaveRequest extends Omit<ServerSaveRequest, 'atomicTransactions'> {
    atomicTransactions?: AtomicTransaction[]
}

export interface CreateRevisionResponse extends Omit<ServerCreateRevisionResponse, 'siteRevision'> {
    siteRevision: {
        revision: number
        version: number
    }
}

export interface CreateRevisionRequest extends ServerCreateRevisionRequest {}
